import api from './index.js';

api.internals.register(api.display.DisplaySelector.DISPLAY, api.display.Display);

export default api;
